import React from 'react';
import { parseAvatar, staffname } from '../../services/utilities';

const StaffTopBar = ({ profileImage, user }) => {
	const details = user.details;
	return (
		<div
			className="card-header bg-dark text-white bg-img p-0 no-border"
			data-stellar-background-ratio="0.1"
			style={{ backgroundImage: 'url(img/b3.jpg)', backgroundPosition: '50% -126.674px' }}
		>
			<div className="bg-dark-overlay no-r-b">
				<div className="d-md-flex">
					<div className="p-4">
						<div className="d-flex">
							<a href="#">
								<span className="avatar w-64">
									<img src={profileImage !== null ? profileImage : parseAvatar(details?.profile_pic)} alt="." /> <i className="on" />
								</span>
							</a>
							<div className="mx-3">
								<h5 className="mt-2">{staffname(details)}</h5>
								<div className="text-fade text-sm">
									<span className="m-r">{user.role?.name}</span>{' '}
									<small>
										<i className="fa fa-map-marker mr-2" />
										{details.department?.name}
									</small>
								</div>
							</div>
						</div>
					</div>
					<span className="flex" />
					<div className="align-items-center d-flex p-4">
						<div className="toolbar">
							<a
								href="#"
								className={`btn btn-sm bg-dark-overlay btn-rounded text-white ${user?.isLoggedIn ? 'bg-success' : 'bg-danger'} active`}
							>
								<span className="d-inline">{user?.isLoggedIn ? 'Online' : 'Offline'}</span>
							</a>
							{/* <a href="#" className="btn btn-sm btn-icon bg-dark-overlay btn-rounded">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width={12}
									height={12}
									viewBox="0 0 24 24"
									fill="none"
									stroke="currentColor"
									strokeWidth={2}
									strokeLinecap="round"
									strokeLinejoin="round"
									className="feather feather-phone text-fade">
									<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
								</svg>
							</a>
							<a href="#" className="btn btn-sm btn-icon bg-dark-overlay btn-rounded">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width={12}
									height={12}
									viewBox="0 0 24 24"
									fill="none"
									stroke="currentColor"
									strokeWidth={2}
									strokeLinecap="round"
									strokeLinejoin="round"
									className="feather feather-more-vertical text-fade">
									<circle cx={12} cy={12} r={1} />
									<circle cx={12} cy={5} r={1} />
									<circle cx={12} cy={19} r={1} />
								</svg>
							</a> */}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default StaffTopBar;
